import { OrganismoI } from "interfaces/Organismo";
import { useState } from "react";
import { Button, Card, Spinner } from "react-bootstrap";
import { OrganismosABM } from "screens/Notificaciones/components/OrganismosABM/OrganismosABM";
import { useOrganismosList } from "./OrganismosListCtx";

export function OrganismosListPageButtons()
{
  const [ open, setOpen ] = useState<boolean>(false);
  const { onOrganismoCreated: addNewOrganismo } = useOrganismosList();

  return (
<>
  <Button size="lg" onClick={() =>
    {
      setOpen(true);
    }}>
      Nuevo Organismo
  </Button>

  <OrganismosABM
    showModal={open}
    actionType={open ? "create" : undefined}
    onClose={() => {
      setOpen(false);
    }}
    onSuccess={(newEl: OrganismoI) => addNewOrganismo(newEl)}
  />

</>
  )
}
